import * as React from "react";
const SvgPhotoCamera = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 2 7.17 4H2v16h20V4h-5.17L15 2H9Zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z",
  fill: "currentColor"
}));
export default SvgPhotoCamera;